<section id="section-report" class="container-fluid mt-1 ">
  <div *ngIf="!editFormat" id="filters" class="row justify-content-between mb-2">
    <div class="col-12 col-md-10 gap-2">
      <div class="row">
        <div class="custom-container col-lg-4 col-md-3 col-sm-6 col-12">
          <app-custom-autocomplete [labelText]="'Bodega'" [list]="listStore" [formControl]="store"
            (onChangeSelect)="getStore($event)"></app-custom-autocomplete>
        </div>
        <div class="custom-container col-lg-1 col-md-2 col-sm-3 col-4 d-flex align-items-end">
          <app-custom-button [title]="'Eliminar filtros'" [severity]="'secondary'" [icon]="'pi pi-filter-slash'"
            (onClick)="clearFilters()"></app-custom-button>
        </div>
      </div>
    </div>
    <hr class="my-1">
  </div>
  <div class="row d-flex justify-content-center" [ngClass]="editFormat ? '' : 'list-liquidation'">
    <app-custom-progress-bar *ngIf="!editFormat" [show]="visibleLoading"
      [heightProgress]="'0.3rem'"></app-custom-progress-bar>
    <div id="container-report" class="col-12 col-lg-12" *ngFor="let liquidation of liquidationPrintModel"
      [hidden]="!editFormat && visibleLoading">
      <table class="page report table-container" id="preview-liquidation-{{liquidation.subrentalMovementId}}">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{liquidation.subrentalMovementId}}" class="head col-12 col-lg-12">
                  <!-- Nombre Compañia -->
                  <p id="nombre-compania-{{liquidation.subrentalMovementId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{liquidation.companyName}}</p>

                  <!-- Nombre Liquidacion con Nro -->
                  <p id="consecutivo-movimiento-{{liquidation.subrentalMovementId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">MOVIMIENTO SUBALQUILER NRO. {{liquidation.movementConsecutive}}</p>

                  <!-- Periodo -->
                  <label id="t-periodo-{{liquidation.subrentalMovementId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-periodo' | formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="periodo-{{liquidation.subrentalMovementId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{liquidation.dateInitial | date: 'dd/MM/yyyy'}} -
                    {{liquidation.dateFinal | date: 'dd/MM/yyyy'}}</p>

                  <!-- Consecutivo Corte -->
                  <p id="consecutivo-corte-{{liquidation.subrentalMovementId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">CORTE Nro. {{liquidation.consecutive}}</p>

                  <!-- Sucursal -->
                  <label id="t-sucursal-{{liquidation.subrentalMovementId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-sucursal' | formatLabelPipe : elementsLabel}}</label>
                  <p id="codigo-sucursal-{{liquidation.subrentalMovementId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{liquidation.branchCode}} </p>
                  <p id="nombre-sucursal-{{liquidation.subrentalMovementId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{liquidation.branchName}}</p>

                  <!-- Bodega -->
                  <label id="t-bodega-{{liquidation.subrentalMovementId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-bodega' | formatLabelPipe : elementsLabel}}</label>
                  <p id="bodega-{{liquidation.subrentalMovementId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{liquidation.storeCodeName}}</p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container">
                <p-table id="detalle-factura-{{liquidation.subrentalMovementId}}"
                  [value]="liquidation.liquidationDetails" [columns]="columns" [reorderableColumns]="editFormat"
                  (onColReorder)="onColumnReorder()" [rowGroupMode]="formatModel.group ? 'subheader' : undefined"
                  [groupRowsBy]="formatModel.group ? 'conceptInvoicingId' : undefined"
                  [sortField]="formatModel.group ? 'conceptInvoicingId' : undefined" sortMode="single"
                  styleClass="p-datatable-sm" showGridlines>

                  <ng-template #header pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" pReorderableColumn
              [id]="'th-' + idMap[col.field].id + '-' + liquidation.subrentalMovementId" (click)="clickTable($event)"
              [class]=" idMap[col.field].id">
              {{ col.header }}
            </th>
          </tr>
          </ng-template>
          <ng-template #body pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
            <tr [pReorderableRow]="index">
              <td *ngFor="let col of columns" [id]="'td-' + idMap[col.field].id + '-' + rowData.id"
                (click)="clickTable($event)">
                {{rowData[col.field] | dynamicFormatPipe: idMap[col.field].type : idMap[col.field].printFormat}}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="groupfooter" let-detail>
            <tr *ngIf="formatModel.group" class="row-group-footer">
              <td [attr.colspan]="columns.length">
                <div class="summary-flex-container"
                  *ngIf="getGroupInfo(liquidation.subrentalMovementId, detail.conceptInvoicingId) as info">
                  <!-- Concepto y valor total -->
                  <p id="foot-group-concept-{{liquidation.subrentalMovementId}}" (click)="onClick()"
                    class="group-concept" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{ info.conceptName }}
                    <ng-container *ngIf="getLabelPrintFormat('foot-group-concept'); else currencyFormat">
                      {{ info.totalValue | dynamicFormatPipe:'decimal':getLabelPrintFormat('foot-group-concept') }}
                    </ng-container>
                    <ng-template #currencyFormat>
                      {{ info.totalValue | currency }}
                    </ng-template>
                  </p>
                </div>
              </td>
            </tr>
          </ng-template>
          </p-table>

          <div id="container-totals" class="d-flex flex-row-reverse pb-2">
            <div id="totals">
              <div class="row">
                <label id="t-foot-valor-pagar-{{liquidation.subrentalMovementId}}" (click)="onClick()"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-foot-valor-pagar' | formatLabelPipe : elementsLabel}}</label>
                <p id="foot-valor-pagar-{{liquidation.subrentalMovementId}}" (click)="onClick()"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  <ng-container *ngIf="getLabelPrintFormat('foot-valor-pagar'); else currencyFormat">
                    {{ liquidation.totalValueToPay | dynamicFormatPipe:'decimal':getLabelPrintFormat('foot-valor-pagar')
                    }}
                  </ng-container>
                  <ng-template #currencyFormat>
                    {{ liquidation.totalValueToPay | currency }}
                  </ng-template>
                </p>
              </div>
            </div>
          </div>
    </div>
    </td>
    </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="1">
          <div class="information-print d-flex">
            <p id="version-cervino" class="fw-bold pe-4 ">{{liquidation.version}}</p>
            <label id="t-fecha-impresion" class="fw-bold pe-2">Fecha: </label>
            <p id="fecha-impresion" class="pe-4">{{dateNow | date: 'dd/MM/yyyy'}}</p>
            <label id="t-hora-impresion" class="fw-bold pe-2">Hora: </label>
            <p id="hora-impresion" class="pe-4"> {{dateNow | date: 'hh:mm:ss a'}}</p>
            <label id="t-usuario-impresion" class="fw-bold pe-2">Usuario: </label>
            <p id="usuario-impresion" class="pe-4"> {{liquidation.userAuthenticated}}</p>
          </div>
          <div class="d-flex flex-column justify-content-center">
            <div class="d-flex justify-content-center">
              <p class="mt-2 information-print">Documento generado con el Software Cervino Web de Altos Software
                SAS. Nit.811.022.121-1. www.altos-soft.com</p>
            </div>
          </div>
        </td>
      </tr>
    </tfoot>
    </table>
  </div>
  </div>
</section>